import React, { useState } from 'react'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import InformationVideoPopup from './InformationVideoPopup'
import ExamRulesPopup from './ExamRulesPopup'
interface InformationConsentCheckboxProps {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}
const InformationConsentCheckbox: React.FC<InformationConsentCheckboxProps> = ({
  checked,
  onCheckedChange,
}) => {
  const [videoPopupOpen, setVideoPopupOpen] = useState(false)
  const [rulesPopupOpen, setRulesPopupOpen] = useState(false)
  const handleVideoLinkClick = (e: React.MouseEvent) => {
    e.preventDefault()
    setVideoPopupOpen(true)
  }
  const handleRulesLinkClick = (e: React.MouseEvent) => {
    e.preventDefault()
    setRulesPopupOpen(true)
  }
  return (
    <>
      <div className="flex items-start space-x-2">
        <Checkbox id="information-consent" checked={checked} onCheckedChange={onCheckedChange} />
        <Label
          htmlFor="information-consent"
          className="text-sm text-gray-700 leading-relaxed cursor-pointer"
        >
          <button
            type="button"
            onClick={handleVideoLinkClick}
            className="text-blue-600 hover:text-blue-800 hover:underline font-medium"
          >
            360° Ortam Tarama Yönergesini
          </button>{' '}
          izledim ve{' '}
          <button
            type="button"
            onClick={handleRulesLinkClick}
            className="text-blue-600 hover:text-blue-800 hover:underline font-medium"
          >
            sınav kuralları
          </button>{' '}
          ile ilgili metni okudum, anladım ve onaylıyorum.
        </Label>
      </div>

      <InformationVideoPopup open={videoPopupOpen} onOpenChange={setVideoPopupOpen} />

      <ExamRulesPopup open={rulesPopupOpen} onOpenChange={setRulesPopupOpen} />
    </>
  )
}
export default InformationConsentCheckbox
